import { render, staticRenderFns } from "./DettaglioTipologia.vue?vue&type=template&id=b80cb25e&"
import script from "./DettaglioTipologia.vue?vue&type=script&lang=js&"
export * from "./DettaglioTipologia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports